import { localizeParam, matchParam } from '$lib/i18n-url';

const localizedParam = localizeParam(2, 'l_terms', {
	en: 'terms-conditions',
	de: 'agb'
});

export const match = (param) => matchParam(param, localizedParam);
